import Lozenge from '@atlaskit/lozenge';
import React from 'react';
import { AppVisibility } from '../../AppsList/constants';
const Visibility = _ref => {
  let {
    appVisibility
  } = _ref;
  switch (appVisibility) {
    case AppVisibility.Public:
      return /*#__PURE__*/React.createElement(Lozenge, {
        appearance: "success"
      }, appVisibility.toUpperCase());
    case AppVisibility.Private:
    case AppVisibility.Rejected:
      return /*#__PURE__*/React.createElement(Lozenge, {
        appearance: "removed"
      }, appVisibility.toUpperCase());
    case AppVisibility.Hidden:
    case AppVisibility.Submitted:
    case AppVisibility.ReadyToLaunch:
      return /*#__PURE__*/React.createElement(Lozenge, {
        appearance: "moved"
      }, appVisibility.toUpperCase());
    default:
      return /*#__PURE__*/React.createElement("div", null);
  }
};
export default Visibility;